import { render, staticRenderFns } from "./InfiniteScroll.vue?vue&type=template&id=38a747bb"
import script from "./InfiniteScroll.vue?vue&type=script&lang=js"
export * from "./InfiniteScroll.vue?vue&type=script&lang=js"
import style0 from "./InfiniteScroll.vue?vue&type=style&index=0&id=38a747bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports